import useTranslate from "hooks/useTranslate";

const AccordionTab = ({ title, step }) => {
    const {t} = useTranslate()
    const isEmpty = () => {
        return [...Array(4 - step)].map((e, i) => <div key={i} className="accordion-tab-empty mr-1"></div>)
    }
    const isFull = () => {
        return [...Array(step)].map((e, i) => <div key={i} style={(title == t('orderStatus50') || title == t('orderStatus60') || title == t('orderStatus70')) ? {backgroundColor:'red'} : {backgroundColor:'#30A46C'}} className="accordion-tab-full  mr-1"></div>)
    }

    return (
        <div className="accordion-wrapper">
            <div className="header-m">{title}
                <div className="d-flex mt-3 mb-3">
                    {isFull()}
                    {isEmpty()}
                </div>
            </div>
        </div>
    );
};

export default AccordionTab;
